function initMobileMenu(){
    var scrollUpPoint = '992px';
    if (window.matchMedia("(max-width: "+scrollUpPoint+")").matches) {
        $('#page-header').css('padding-top',$('#page-header .scrollbar').height() + 1);
        $('#page-header .scrollbar').addClass('fixed');
    }
    $(window).on('resize',function () {
        //recalc the needed top padding for the fixed header
        if (window.matchMedia("(max-width: "+scrollUpPoint+")").matches) {
            $('#page-header').css('padding-top',$('#page-header .scrollbar').height() + 1);
            $('#page-header .scrollbar').addClass('fixed');
        }else{
            $('#page-header').css('padding-top',0);
            $('#page-header .scrollbar').removeClass('fixed');
        }

    });
    //Mobi menu
    $('body .hamburger').on('click',function () {
        $('body').toggleClass('mobi-menu-open');
        $(this).toggleClass('is-active')
        $.scrollLock();
        if($('#page-header .navbar-main').height() <= $('#page-header .navbar-main .menu-lvl-0').height()){
            $('#page-header .navbar-main').css('overflow-y','scroll');
            $('#page-header .navbar-main .menu-lvl-0').addClass('static');
            $('#page-header .navbar-main .menu-lvl-0').css('top',$('#page-header .scrollbar').height() + 1);
        }else {
            $('#page-header .navbar-main .menu-lvl-0').removeClass('static');
            $('#page-header .navbar-main .menu-lvl-0').removeAttr('style');
        }
    })
    //
    // $('.navbar-main a').on('click',function () {
    //     if(/^#/.test($(this).attr('href'))) {
    //         $('body .hamburger').trigger('click');
    //     }
    // });
    var navControl = $('#page-header .scrollbar').first();
    //get height of the step
    var pseudoAfterHeight = window.getComputedStyle(navControl.get(0), ':after').height;
    $(document).on('scrollUp', function () {
        if (window.matchMedia("(max-width: "+scrollUpPoint+")").matches) {
            //show the menu only if we are a bit over the bottom. So we avoid to trigger the menu on ios, when the user scrolls hard to the bottom and the animation of ios gos over the window limits and scrolls up
            var maxScrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            if (maxScrollHeight - $(window).scrollTop() > 100) {
                navControl.animate({
                    top: 0
                }, 150)
            }
        }
    });
    $(document).on('scrollDown', function () {
        if (window.matchMedia("(max-width: "+scrollUpPoint+")").matches) {
            if ($(window).scrollTop() > 100) {
                navControl.animate({
                    top: (navControl.first().outerHeight() + 15 + parseInt(pseudoAfterHeight)) * -1
                });
            }
        }
    });

}